<template lang="pug">
.page-top-area.fixed-top
header-mobile
    template(v-slot:leftIcon)
        q-icon.q-mr-sm.q-py-xs.q-pl-xs.q-pr-sm.back-icon(
            name="etabl:arrow_prev"
            color="positive"
            size="xs"
            @click="router.go(-1)")
    template(v-slot:title)
        h1.font-14.text-positive.text-weight-bold.text-ellipsis(style="width: 80%;" @click="router.go(-1)") {{ product.name }}
    template(v-slot:share)
        q-icon.share(
            @click="app ? share : sharesList = true"
            name="etabl:share"
            color="positive"
            size="24px")

.row.items-center.q-py-md.q-px-md.fixed(v-if="fixTitle")
    q-icon.q-mr-sm.q-py-xs.q-pl-xs.q-pr-sm.back-icon(
        name="etabl:arrow_prev"
        color="positive"
        size="xs"
        @click="router.go(-1)")
    h1.font-14.text-positive.text-weight-bold.text-ellipsis(style="width: 80%;" @click="router.go(-1)") {{ product.name }}
    q-icon.share(
        v-if="isApp"
        @click="share"
        name="etabl:share"
        color="positive"
        size="24px")
    q-scroll-area.full-width.anchors.bg-grey-5(
        ref="scrollAreaFixed"
        v-if="!app"
        :thumb-style="{display: 'none'}"
        style="margin-bottom: 4%;"
    )
        .row.no-wrap
            template(v-for="item in anchorLinks")
                template(v-if="item.condition")
                    .font-16.white-space-nowrap.q-px-sm.line-height-40(@click="scrollTo(item.value,item.value)" :class="[activeAnchorLink === item.value ? 'text-positive' : 'text-grey-9']")
                        | {{ item.label }}
.q-mt-md.relative-position.product
    q-scroll-area.full-width.anchors.bg-grey-5(
        ref="scrollAreaFull"
        v-if="!app"
        :thumb-style="{display: 'none'}"
        style="margin-bottom: 4%;")
        .row.no-wrap
            template(v-for="item in anchorLinks")
                template(v-if="item.condition")
                    .font-16.white-space-nowrap.q-px-sm.line-height-40(
                        @click="scrollTo(item.value)"
                        :class="[activeAnchorLink === item.value ? 'text-positive' : 'text-grey-9'] "
                        :id="`topAnchor-${item.value}`"
                    )
                        | {{ item.label }}
    //.row.q-pl-md
    //    q-icon.q-mt-xs.q-mr-xs(
    //        v-if="product.isMarker"
    //        name="etabl:side-sale"
    //        size="22px"
    //        color="negative")
    //        base-tooltip(title="Скидка")

.product-info.q-mt-sm
    .q-px-md
        //.font-16.text-positive.text-weight-bold {{ product.name }}
        //.font-14.text-primary {{ product.subtitleShort }}
        .font-18.text-weight-regular.text-primary.q-pb-md
            | {{ product.name }} {{ product.subtitleShort }}
        .row.justify-center.relative-position#overall(style="height: 250px;")
            div.product__disable(
                v-if="notAvailable"
            )
            .absolute-top-left.custom-a-top-left
                .q-px-sm.q-py-xs.text-white.font-12.text-weight-regular.b-radius-16(
                    v-if="product.discount800 || product.discount300 || (product.priceCrossed  && !notAvailable) || product?.productActivities?.length"
                    :class="promotionNameplate"
                )
                    div(v-if="product?.advertisment_info?.length && product?.advertisment_info[0]?.title_short") {{product?.advertisment_info[0]?.title_short}}
                    div(v-else-if="product?.productActivities?.length" ) {{product?.productActivities[0].title}}
                    div(v-else-if="product?.advertismentTitles?.length" ) {{product?.advertismentTitles[0]}}
                    div(v-else ) Акция

                    //base-tooltip(
                    //    title="Акция действительна только в розничной сети аптек «Табле.Точка»"
                    //    :maxWidth="'250px'"
                    //    :offset="[ 14, 14 ]"
                    //    anchor="top middle"
                    //    self="bottom middle"
                    //)
            img(
                style="max-width: 90%; max-height: 100%;"
                :src="product.previewImage"
                :title="`${product.name} ${ product.subtitleShort } (${ product.manufacture }, ${ product.country })`"
                :alt="`${product.name} ${ product.subtitleShort } (${ product.manufacture }, ${ product.country })`")
    .q-mx-md.q-pt-xs
        .font-12.text-grey-9.full-width Фотографии представлены в ознакомительных целях. Внешний вид товара может отличаться от изображенного на фотографии
        template(v-if="product.productPackages")
            .line-height-18.q-mt-md.text-primary.text-weight-medium.font-14
                | Количество
            .row.q-mt-sm.q-mb-lg(style="row-gap:16px")
                .package-form.b-radius-16.q-mr-md.text-primary.font-16(
                    v-for="item in product.productPackages"
                    @click="goTo(item.url)"
                    :class="item.is_checked ? 'active-form' : ''")
                    .line-height-18
                        | {{ item.number }}
        template(v-if="product.productDoses")
            .line-height-18.q-mt-md.text-primary.text-weight-medium.font-14(:class="product.productPackages ? '' : 'q-mt-lg'")
                | Дозировка:
            .row.q-mt-sm(style="row-gap:16px")
                .package-form.b-radius-16.q-mr-md.font-16(
                    v-for="item in product.productDoses"
                    @click="goTo(item.url)"
                    :class="item.is_checked ? 'active-form' : ''")
                    .line-height-18
                        | {{ item.number }}
        template(v-if="product.productSizes")
            .line-height-18.q-mt-md.text-primary.text-weight-medium.font-14(:class="product.productPackages ? '' : 'q-mt-lg'")
                | Размеры:
            .row.q-mt-sm(style="row-gap:16px")
                .package-form.b-radius-16.q-mr-md.q-mb-md.font-16(
                    v-for="item in product.productSizes"
                    @click="goTo(item.url)"
                    :class="item.is_checked ? 'active-form' : ''")
                    .line-height-18
                        | {{ item.number }}
        .row.text-weight-medium.q-pt-lg.items-center(v-if="!notAvailable")
            .row.items-center(v-if="product.isMarker && salePercent > 0")
                .text-left.font-14.q-mr-sm.text-weight-regular.text-grey-9(
                    style="text-decoration: line-through;")
                    span(v-if="!userAddress?.address_id" ) от&nbsp;
                    | {{ new Intl.NumberFormat('ru-RU').format(product.priceCrossed) }}
                    span &nbsp;₽
                .text-left.text-weight-bold.text-positive.font-20
                    span(v-if="!userAddress?.address_id" ) от&nbsp;
                    | {{ new Intl.NumberFormat('ru-RU').format(product.price) }}
                    span &nbsp;₽
                .sale.q-mr-md.b-radius-16.border-negative.flex.items-center.q-ml-sm(style="padding: 2px 4px")
                    .font-12.line-height-16.text-negative
                        | {{ salePercent }}%
            .text-left.text-weight-bold.text-positive.font-20(v-else)
                span(v-if="!product.isMarker" )
                    | от&nbsp;
                span
                    |  {{ new Intl.NumberFormat('ru-RU').format(product.price) }}
                    span &nbsp;₽
                //| от {{ new Intl.NumberFormat('ru-RU').format(product.price) }}
                //span &nbsp;₽
            // q-icon.q-ml-lg(
            //     v-if="delivery && !freeDelivery && product.qDs"
            //     name="etabl:car_delivery"
            //     size="24px"
            //     color="grey-9")
            //     base-mobile-tooltip(title="Возможна доставка на дом")
            q-icon.q-ml-sm(
                v-if="freeDelivery && (product.qDs || product.isPrescription)"
                :name="product.delivery == 1 ? 'etabl:delivery_one' : 'etabl:delivery_two'"
                size="24px"
                :color="product.delivery == 1 ? 'positive' : 'deep-purple-6'"
            )
                q-tooltip(
                    content-class="delivery-tooltip"
                    anchor="top middle"
                    self="center middle"
                    :hide-delay="3000"
                    :offset="[0, 20]"
                )
                base-mobile-tooltip(:title="product.delivery == 1 ? 'Бесплатная доставка' : 'Бесплатная доставка при заказе от 2 товаров'")
        .row.q-mt-lg(v-if="(product?.advertisment_info?.length || product?.productActivities?.length) && !notAvailable && product.qDs >= 1" )
            .text-primary.font-24.text-weight-bold.row.full-width
                div.q-mb-sm Участвует в акциях:
            .row.q-mb-sm(style="gap: 8px" )
                .q-px-sm.q-py-xs.text-white.font-12.text-weight-regular.b-radius-16(
                    v-for="(sale,idx) of product?.productActivities?.length ? product?.productActivities : product.advertisment_info"
                    style="max-width: fit-content"
                    :class="promotionNameplate"
                )
                    router-link.text-white(
                        :to="city ? `/${city?.slug}/marketing/${sale.advertisment_id}` : `/marketing/${sale.advertisment_id}`"
                        target="_blank"
                    )
                        div {{sale.title}}

            div.full-width
                .text-grey-9.font-12.text-weight-regular(
                    style="max-width: fit-content"
                ) *Скидки и акции не суммируются
        .row.q-mt-lg
            .text-primary.font-24.text-weight-bold.row
                div Способы получения
        .q-mt-md(v-if="!notAvailable && (!product.limit === 0 || !product.pku)")
            .row.q-mb-md.items-center
                //q-icon(
                //    name="etabl:completed"
                //    size="14px"
                //    color="positive")
                .text-primary(v-if="product.qDs" )
                    | В наличии:
                .q-ml-xs.text-positive(@click="showMap = true" v-if="product.qDs")
                    | в {{ product.qDs }} {{ drugstoresTodayText }}
            // .row.q-mb-sm.items-center(v-if="product.isPreorder")
            //     q-icon(
            //         name="etabl:completed"
            //         size="14px"
            //         color="positive")
            //     .q-ml-sm.text-grey
            //         | Заказать со склада:
            //     .q-ml-xs.text-positive(@click="showMap = true")
            //         template(v-if="isOrthopedics")
            //             | в {{ orthopedicsDrugstores.length }} {{ drugstoresPreorderText }}
            //         template(v-else)
            //             | в {{ drugstores.length }} {{ orthopedicsDrugstoresPreorderText }}
            .row.items-center.q-mb-md(v-if="product.preorder && !product.pku")
                .text-primary
                    | Под заказ:
                .q-ml-xs.text-positive(@click="showMap = true")
                    template(v-if="isOrthopedics")
                        | в {{ orthopedicsDrugstores.length }} {{ drugstoresPreorderText }}
                    template(v-else)
                        | в {{ drugstores.length }} {{ orthopedicsDrugstoresPreorderText }}
            .row.items-center.q-mb-md(v-if="(freeDelivery || delivery) && (product.qDs || product.isPreorder)")
                //q-icon(
                //    name="etabl:completed"
                //    size="14px"
                //    color="positive")
                .text-primary
                    | Доставка курьером:
                .q-ml-xs.text-positive(v-if="product.delivery == 0")
                    | от 200 ₽
                .q-ml-xs.text-positive(v-if="product.delivery == 1")
                    | бесплатно
                .q-ml-xs.text-positive(v-if="product.delivery == 2")
                    | бесплатно от 2 шт
        .q-mt-lg
            .row.items-center(v-if="product.isPrescription")
                .row.items-center.no-wrap.q-pb-sm(v-if="!product.isErp" @click="showPrecriptionTooltip = !showPrecriptionTooltip")
                    q-icon(
                        size="24px"
                        name="img:rx.svg")
                    span.q-pl-sm.font-14 Рецептурный препарат
                .row.items-center.no-wrap.q-pb-sm(v-else @click="showErpTooltip = !showErpTooltip")
                    q-icon(
                        size="24px"
                        name="img:rx_e.svg")
                    span.q-pl-sm.font-14 Доставка по электронному рецепту
            .row.items-center.no-wrap.q-pb-sm(v-if="product.truCode")
                q-icon(
                    size="24px"
                    name="img:fss.svg")
                span.q-pl-sm.font-14 Оплата с помощью сертификата ФСС
            .row.items-center.no-wrap(v-if="product.cold" @click="showTermoTooltip = !showTermoTooltip")
                q-icon(
                    size="24px"
                    color="light-blue"
                    name="etabl:frost")
                span.q-pl-sm.font-14 Термолабильный препарат
    div#analogs-unavaliable
        product-slider-mobile(
            v-if="productAnalogs?.length && notAvailable"
            label="Аналоги"
            :slides="productAnalogs")
    //.q-mx-md.q-mt-md
    //    .text-positive.font-18.text-weight-bold.q-mb-xs В копмлекте выгоднее!
    //    .font-13.q-mb-sm Купите 2 товара и получите скидку на оба
    //    .bg-secondary.b-radius-16.q-px-sm(style="box-shadow: 2px 2px 10px 0px #9999991A; padding-top: 12.5px; padding-bottom: 12.5px; max-width: 178px;")
    //        .row.justify-center
    //            img.q-mb-sm(:src="product.previewImage" style="max-height: 97px !important")
    //        .q-mb-sm.font-12 Но-шпа табл. п.п.о. 100 мг N100
    //        .text-positive.font-16.text-weight-bold от 799.0 ₽
    .q-px-md
        .q-mt-lg
            .row.text-primary.items-top
                .col-7.font-14 Страна производитель:
                .col-5.row.justify-end.items-center
                    .font-14.text-right {{ product.country }}
                    q-icon(
                        name="etabl:question"
                        size="16px"
                        color="grey-9").q-ml-sm
                        base-mobile-tooltip(:offset="[0, 40]" title="Страна производства может отличаться от указанной на сайте. Проверяйте, пожалуйста, при получении заказа")
            q-separator(spaced="8px" color="grey-13")
            .row.text-primary.items-top
                .col-6.font-14 Производитель:
                .col-6.font-14.text-right
                    router-link.font-14.link(
                        :to="`/search?query=${product.manufacture}&noTerm=true&limit=20`")
                        | {{ product.manufacture }}
                        q-icon(
                            @click.prevent.stop = ""
                            name="etabl:question"
                            size="16px"
                            color="grey-9").q-ml-sm
                            base-mobile-tooltip(:offset="[0, 40]" title="Страна производства может отличаться от указанной на сайте. Проверяйте, пожалуйста, при получении заказа")
            q-separator(spaced="8px" color="grey-13")
            .row.text-primary.items-top
                .col-6.font-14 Общее описание:
                .col-6.font-14.text-right {{ product.type }}
            q-separator(spaced="8px" color="grey-13")
            template(v-if="product.packingForm")
                .row.text-primary.items-top
                    .col-6.font-14 Форма выпуска:
                    .col-6.font-14.text-right {{ product.packingForm }}
                q-separator(spaced="8px" color="grey-13")
            template(v-if="product.number[0]")
                .row.text-primary.items-top
                    .col-7.font-14 Количество в упаковке:
                    .col-5.font-14.text-right {{ product.number[0] }}
                q-separator(spaced="8px" color="grey-13")
            template(v-if="product.mnn.length")
                .row.text-primary.items-top
                    .col-6.font-14 Действующее вещество:
                    .col-6.text-right
                        router-link.font-13.link(
                            v-for="(link, i) in product.mnn"
                            :to="`/search?query=${link}&noTerm=true&limit=20`")
                            | {{ link }}
                            br
                q-separator.q-mt-sm( color="grey-13")
            template(v-if="(product.groupCategory.cod == '000000288' || product.groupCategory.cod == '000000199' || product.groupCategory.cod == '000000252' || product.groupCategory.cod == '000000346') && product.brand")
                .row.text-primary.items-top.q-mt-sm
                    .col-6.font-14 Бренд:
                    .col-6.text-right
                        router-link.font-13.link(
                            :to="`/search?query=${product.brand}&noTerm=true&limit=20`")
                            | {{ product.brand }}
                            br
                q-separator.q-mt-sm( color="grey-13")
    .q-mx-md.q-py-lg(v-if="product.qDs || (product.preorder && !product.pku)")
        .full-width.q-pa-md.product__map-card#drugstores(
            v-if="product.qDs || (product.preorder && !product.pku)"
            style="background: linear-gradient( rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.2) ), url('interface/Map.png');")
            .font-16.text-positive(v-if="product.limit === 0 || product.pku") Только в
                strong {{ product.qDs }}
                | &nbsp;{{ drugstoresTodayText }}
            template(v-else)
                .font-16.text-positive.text-center.text-weight-bold(v-if="product.qDs") Наличие в аптеках
                //    strong {{ product.qDs }}
                //    | &nbsp;{{ drugstoresTodayText }}
                //.font-16.text-positive(v-if="product.preorder && !product.qDs") Самовывоз в
                //    template(v-if="isOrthopedics")
                //        strong {{ orthopedicsDrugstores.length }}
                //        | &nbsp;{{ orthopedicsDrugstoresPreorderText }}
                //    template(v-if="isOptics")
                //        strong {{ opticsDrugstores.length }}
                //        | &nbsp;{{ opticsDrugstoresPreorderText }}
                //    template(v-else)
                //        strong {{ drugstores.length }}
                //        | &nbsp;{{ drugstoresPreorderText }}
            base-btn.q-mt-sm(
                height="40"
                font_size="14"
                bradius="16"
                label="Показать на карте"
                @click="showMap = true")
                //div#analogs
    .additional#additional(v-if="additionalSales?.length")
        .text-primary.font-24.text-weight-bold.q-pl-md.q-py-sm.line-height-26
            | С этим товаром покупают
        product-slider-mobile(
            :small-priveiew="true"
            :product-card-preview="true"
            :slides="additionalSales"
        )
    div#analogs
        product-slider-mobile(
            v-if="productAnalogs?.length && !notAvailable"
            label="Аналоги"
            :slides="productAnalogs")
    .q-px-md.q-mt-lg(v-if="description")
        h2.font-22.text-primary.text-weight-medium.no-padding Инструкция по применению
    q-scroll-area.full-width.anchors.anchors-instruction#instruction(
        v-if="description?.value"
        :thumb-style="{display: 'none'}")
        .row.no-wrap.anchors__instruction.q-py-md
            template(v-for="(item,idx) in description?.value")
                .font-18.white-space-nowrap.q-mx-sm.anchors__instruction-item.text-weight-regular(@click="scrollTo(item.title,_,true,idx)" v-if="item.value" :class="[item.show ? 'text-positive' : 'text-primary']")
                    | {{ item.title }}
    .q-px-md(v-if="description")
        template(v-for="(item, index) in description.value")
            template(v-if="item.value")
                .row.justify-between.items-start.q-pt-sm(
                    :class="item.show ? 'q-pb-sm': ''"
                    :id="item.title"
                    @click="currentInstruction == item.title ? currentInstruction = '' : item.show = !item.show")
                    h2.col-11.font-14.text-weight-regular.no-padding {{ item.title }}
                    q-icon.col-1(
                        name="etabl:arrow_down"
                        :color="(item.show || currentInstruction == item.title) ? 'positive' : 'grey-13'"
                        :class="[(item.show || currentInstruction == item.title) ? 'rotate-180' : '']")
                q-slide-transition(:duration="1")
                    .font-12(v-show="(item.title == currentInstruction) || item.show") {{ item.value }}
                q-separator.q-mt-sm(color="grey-13")
    .q-px-md
        .q-pt-sm.font-12
            | Производитель оставляет за собой право менять инструкцию и/или характеристики товара,
            | внешний вид упаковки и комплектацию без предварительного уведомления торговой площадки.
    div#formfactor
        product-slider-mobile(
            v-if="formFactor?.length && !notAvailable"
            :label="product.groupCategory.code == '000000001' ? 'Лекарственная форма' : 'Форма выпуска'"
            :slides="formFactor")
    .q-px-md.q-mt-lg#reviews
        h2.no-padding.font-24.text-primary.text-weight-bold(v-if="product.reviews?.length") Отзывы о {{ product.name }} {{ product.subtitleShort }}
        h2.no-padding.font-24.text-primary.text-weight-bold(v-else) Отзывы
        .row.q-mt-sm(v-if="product.reviews?.length")
            q-icon.q-mr-sm(
                v-for="n in productRatingRound"
                name="etabl:star-fill"
                size="20px"
                color="positive"
            )
            q-icon.q-mr-sm(
                v-for="n in 5 - productRatingRound"
                name="etabl:star"
                size="20px"
                color="positive"
            )
            .q-mt-xs.text-primary
                | Рейтинг {{ productRating }} на основе {{ product.reviews?.length }} отзывов
        base-btn.q-mt-md(
            height="40"
            font_size="16"
            bradius="16"
            label="Написать отзыв"
            @click="showReviewForm")
        .q-mt-md(v-if="!product.reviews?.length")
            | Пока нет отзывов о данном товаре
        .column(v-for="(item, index) in product.reviews" :key="index")
            .q-mt-md(v-if="showAllReviews || index <= 2")
                .row
                    q-icon.q-mr-sm(
                        v-for="n in item.rating"
                        name="etabl:star-fill"
                        size="20px"
                        color="positive"
                    )
                    q-icon.q-mr-sm(
                        v-for="n in 5 - item.rating"
                        name="etabl:star"
                        size="20px"
                        color="positive"
                    )
                .q-mt-sm
                    | {{ item.review }}
                .q-mt-sm.text-weight-medium.text-grey-9
                    | {{ item.name }} | {{ new Date( item.created).toLocaleDateString('ru-Ru', {day: '2-digit', month: 'long', year: 'numeric'}) }}
                q-separator.q-mt-sm(color="green-7")
        base-btn(
            v-if="product.reviews?.length > 3"
            :label="showAllReviews ? 'Скрыть отзывы' : 'Смотреть все отзывы'"
            bradius="20"
            height="40"
            text_color="positive"
            border="1px solid #0ca551"
            background="bg-secondary"
            backgroundHEX="#fbfafa"
            @click="showAllReviews = !showAllReviews"
        ).q-mt-sm
    product-slider-mobile(
        v-if="history?.length && userAuthorized"
        label="Вы недавно просматривали"
        :slides="history"
        :small-priveiew="true"
        product-card-preview
    )
    .font-12.text-weight-regular.q-py-lg.q-px-md(v-html="product.seoContent" v-if="product.seoContent")

q-no-ssr
    .full-width.fixed-bottom.bg-secondary.q-px-sm.q-pb-xs.q-pt-sm.row.items-center.product__button-block
        .col-2.row.justify-center
            q-icon(
                name="etabl:heart"
                size="22px"
                :color="isFavourite ? 'negative' : 'grey-7'"
                @click="updateFavourite")
        .col-10.row.justify-between.no-wrap.relative-position.overflow-hidden(style="height: 46px")
            base-btn(
                v-if="product.limit === 0 || product.pku"
                height="46"
                font_size="16"
                label="Только в аптеке"
                loading_color="secondary"
                backgroundHEX="#f5f5f5"
                text_color="primary"
                bradius="16"
                :loading="loading"
                disable)
            template(v-else)
                .transition-all(:class="inCart ? 'col-7 q-pr-sm' : 'col-12'")
                    base-btn(
                        height="46"
                        font_size="16"
                        bradius="16"
                        :border="notAvailable ? (subscribe ? '1px solid #0ca551' : '') : ''"
                        :text_color="notAvailable ? (subscribe ? 'grey-12' : 'primary') : secondary"
                        :label="notAvailable ? (subscribe ? 'Отменить уведомление' : 'Уведомить о поступлении') : (inCart ? 'В корзине' : 'В корзину')"
                        :subLabel="notAvailable ? false : (inCart ? 'Перейти' : `${new Intl.NumberFormat('ru-RU').format(product.price)} ₽`)"
                        loading_color="secondary"
                        :color="notAvailable ? (subscribe ? 'secondary' : 'grey-14') : 'positive'"
                        :loading="loading"
                        :disable="loading"
                        @click="notAvailable ? (subscribe ? unSubscribeProduct() : subscribeProduct()) : (inCart ? router.push('/basket') : addToCart())")
                .col-5.full-height.product__counter
                    .row.justify-between.full-width.full-height.b-radius-16.overflow-hidden
                        q-btn.col-4.justify-center.items-center.overflow-hidden.product__button-counter(
                            unelevated
                            @click.prevent.stop="setAmount(0)") &ndash;
                        .font-12.text-weight-bold.row.col-4.justify-center.items-center.bg-secondary {{ amount }}
                        q-btn.col-4.justify-center.items-center.overflow-hidden.product__button-counter(
                            unelevated
                            :class="`product__button-${preventAmoutUp ? 'disable' : 'secondary'}`"
                            @click.prevent.stop="preventAmoutUp ? limit() : setAmount(1)") +
q-dialog.mobile-map(
    v-model="showMap"
    full-width
    full-height
    transition-show="slide-left"
    transition-hide="slide-right"
    :maximized="true")
    .full-width.full-height.bg-secondary.b-radius-0.relative-position
        base-mobile-map(
            :drugstoreOnly="product.limit === 0 || product.pku"
            productPage
            :basket="false"
            :products="[product]"
            :productName="product.name"
            :drugstores="drugstores"
            :isOrthopedics="isOrthopedics"
            :isOptics="isOptics"
            :qDs="!!product.q_ds"
            @hide="showMap = false")
base-button-top-mobile
q-dialog(
    full-width
    position="bottom"
    v-model="sharesList"
    transition-show="slide-up"
    transition-hide="slide-down")
    .full-width.full-height.bg-secondary.relative-position.review-form.q-pa-md
        .absolute-top-right.q-ma-md(
            v-close-popup)
            q-icon(
                name="etabl:cross"
                size="16px"
                color="scondary")
        .q-pb-md.text-16.font-weight-medium.text-center
            | Поделиться
        template(v-for="share in shares")
            a.row.link.q-mb-md(:href="share.link" target="_blank" @click="sharesList = false")
                q-icon(
                    :name="`etabl:${share.icon}`"
                    size="20px"
                    color="grey-9"
                )
                .line-height-20.text-positive.q-ml-sm
                    | {{ share.title }}
        .row.cursor-pointer(@click="copy")
            q-icon(
                name="etabl:copy-round"
                size="20px"
                color="grey-9"
            )
            .line-height-20.text-positive.q-ml-sm
                | Скопировать ссылку
review-form-mobile(
    :reviewForm="reviewForm"
    :productId="product.id"
    @closeReviewForm="closeReviewForm"
)
q-dialog(
    full-width
    position="bottom"
    v-model="showErpTooltip"
    transition-show="slide-up"
    transition-hide="slide-down"
    @hide="showErpTooltip = false")
    .full-width.bg-secondary.relative-position.q-pa-md.font-12.line-height-16
        .absolute-top-right.q-ma-md(
            v-close-popup)
            q-icon(
                name="etabl:cross"
                size="16px"
                color="scondary")
        .q-mt-lg
            | Жителям Белгородской области теперь доступн доставка курьером выписанных по электронному рецепту лекарств. 
        .flex.text-weight-medium
            span Узнайте больше об услуге&nbsp;
            .text-positive.q-mb-md(style="text-decoration: underline;" @click="openWindow('/policy')") «Электоронные рецепты»
            base-btn(
                label="Как сделать заказ по ЭР"
                height="42"
                @click.prevent.stop="openWindow('/how-to-order?isErp=true')"
                font_size="16"
                bradius="16"
                loading_color="secondary"
            )
q-dialog(
    full-width
    position="bottom"
    v-model="showPrecriptionTooltip"
    transition-show="slide-up"
    transition-hide="slide-down"
    @hide="showPrecriptionTooltip = false")
    .full-width.bg-secondary.relative-position.q-pa-md.font-12.line-height-16
        .absolute-top-right.q-ma-md(
            v-close-popup)
            q-icon(
                name="etabl:cross"
                size="16px"
                color="scondary")
        .q-mt-lg.row.items-center
            q-icon(
                name="img:rx.svg"
                size="24px"
            ).q-mr-sm
            .font-14.text-weight-medium
                | Этот препарат является рецептурным
        .flex.q-mt-sm
            | Вы можете заказать его на сайте, но при получении в аптеке потребуется предъявить рецепт.
            .q-mt-sm.q-mb-lg
                | Без рецепта фармацевт может отказать в продаже, согласно правилам отпуска лекарственных средств.
            base-btn(
                label="Понятно"
                height="42"
                @click.prevent.stop="showPrecriptionTooltip = false"
                font_size="16"
                bradius="16"
                loading_color="secondary"
            )
q-dialog(
    full-width
    position="bottom"
    v-model="showTermoTooltip"
    transition-show="slide-up"
    transition-hide="slide-down"
    @hide="showTermoTooltip = false")
    .full-width.bg-secondary.relative-position.q-pa-md.font-12.line-height-16
        .absolute-top-right.q-ma-md(
            v-close-popup)
            q-icon(
                name="etabl:cross"
                size="16px"
                color="scondary")
        .q-mt-lg.row.items-center
            q-icon(
                name="etabl:frost"
                size="24px"
                color="light-blue"
            ).q-mr-sm
            .font-14.text-weight-medium
                | Условия хранения
        .flex.q-mt-sm
            .q-mb-lg
                | {{ termoText }}
            base-btn(
                label="Понятно"
                height="42"
                @click.prevent.stop="showTermoTooltip = false"
                font_size="16"
                bradius="16"
                loading_color="secondary"
            )
</template>

<script>
import {copyToClipboard, scroll, useQuasar} from 'quasar';
import {computed, onMounted, onUnmounted, reactive, ref, watch} from 'vue';
import {useRoute, useRouter} from 'vue-router';
import {useStore} from 'vuex';
import BaseBtn from 'components/Base/BaseBtn.vue';
import BaseMobileTooltip from 'components/Base/BaseMobileTooltip.vue';
import BaseTextblock from 'components/Base/BaseTextblock.vue';
import HeaderMobile from 'components/Header/HeaderMobile.vue';
import BaseBreadcrumbs from 'components/Base/BaseBreadcrumbs.vue';
import BaseMobileMap from 'src/components/Base/BaseMobileMap.vue';
import PreviewDesktop from 'components/Preview/PreviewDesktop.vue';
import BaseButtonTopMobile from 'components/Base/BaseButtonTopMobile.vue';
import ProductSliderMobile from 'components/ProductSlider/ProductSliderMobile.vue';
import ReviewFormMobile from 'src/components/Review/ReviewFormMobile.vue';
import debounce from 'lodash/debounce';

const {getScrollTarget, setVerticalScrollPosition} = scroll;
export default {
    name: 'ProductMobile',
    components: {
        BaseBtn,
        BaseMobileTooltip,
        HeaderMobile,
        BaseTextblock,
        BaseMobileMap,
        PreviewDesktop,
        BaseBreadcrumbs,
        BaseButtonTopMobile,
        ProductSliderMobile,
        ReviewFormMobile,
    },
    setup() {
        const route = useRoute();
        const router = useRouter();
        const store = useStore();
        const $q = useQuasar();

        const amount = ref(1);
        const inventoryList = {};
        const amountTimer = ref();
        const inventories = ref();
        const inStock = ref(false);
        const openMap = ref(false);
        const navBlock = ref(null);
        const loading = ref(false);
        const showMap = ref(false);
        const fixedMenu = ref(false);
        const currentCharact = ref(0);
        const routeObj = reactive([]);
        const readyCrumbs = ref(false);
        const heightHeader = ref(null);
        const containerOffset = ref(null);
        const fixedMenuDisatnce = ref(null);
        const reviewForm = ref(false);
        const showAllReviews = ref(false);
        const name = ref(null);
        const email = ref(null);
        const subscribe = ref(true);
        const currentInstruction = ref('');
        const fixTitle = ref(false);
        const orthopedicsDrugstoreList = ref([]);
        const isLocalFavourite = ref(false);
        const sharesList = ref(false);
        const showErpTooltip = ref(false);
        const showPrecriptionTooltip = ref(false);
        const showTermoTooltip = ref(false);
        const scrollAreaFixed = ref(null);
        const scrollAreaFull = ref(null);
        const scrollPosition = ref(0);

        // данные продукта
        const product = computed(() => {
            for (const key of Object.keys(inventoryList)) {
                delete inventoryList[key];
            }
            ;

            const prod = JSON.parse(JSON.stringify(store.getters['products/PRODUCT']));
            if (prod.inventoryList)
                prod.inventoryList.forEach((drugstore) => {
                    inventoryList[drugstore.id] = drugstore;
                });
            return prod;
        });

        // город пользователя
        const city = computed(() => store.getters['cityForm/CITY']);

        const userAddress = computed(() => store.getters['user/USER_ADDRESS']);

        const preorderAvialable = computed(() => !!product.value.isPreorder);

        const drugstoresCount = computed(() => product.value.inventoryList.length);

        const drugstores = computed(() => {
            let result = product.value.inventoryList.filter((item) => !item.isParcelAutomat);

            let drugstoreList = [];

            result.forEach((item) => {
                let drugstore = Object.assign({}, item);
                drugstore['preorder_available'] = preorderAvialable.value;

                if (inventoryList[item.id]) {
                    drugstore['drugstore_balance'] = inventoryList[item.id].drugstoreBalance;
                    drugstore['drugstore_price'] = inventoryList[item.id].drugstorePrice;
                    drugstoreList.push(drugstore);
                } else {
                    drugstore['drugstore_balance'] = 0;
                    drugstoreList.push(drugstore);
                }
            });

            return drugstoreList;
        });

        const orthopedicsDrugstores = computed(() => {
            return drugstores.value.filter((item) => item.isOrthopedics || item.drugstoreBalance || item.preorder_available);
        });

        const opticsDrugstores = computed(() => {
            return drugstores.value.filter((item) => item.isOptics || item.drugstoreBalance || item.preorder_available);
        });

        // аналоги продукта
        const productAnalogs = computed(() => {
            return product.value.analogProducts;
        });

        // продукты другой формы выпуска
        const formFactor = computed(() => {
            return product.value.brandProducts;
        });

        // дозаказ
        const additionalSales = computed(() => {
            return product.value.additionalProducts;
        });

        //скидка

        const salePercent = computed(() => {
            if (product.value.priceCrossed) {
                const percent = ((product.value.priceCrossed - product.value.price) / product.value.priceCrossed) * 100;
                const decimalPart = Math.floor((percent % 1) * 10);

                if (decimalPart > 5) {
                    return `${Math.ceil(percent)}`;
                } else {
                    return `${Math.floor(percent)}`;
                }
            } else {
                return false;
            }
        });


        // история просмотров
        const history = computed(() => store.getters['advertisement/HISTORY']);

        // данные пользователя
        const userFavouriteProducts = computed(() => store.getters['user/USER_FAVOURITE_PRODUCTS']);
        const userStorageFavouriteProducts = computed(() => store.getters['localStorage/FAVOURITES']);
        const userCityId = computed(() => store.getters['user/USER_CITY_ID']);
        const userAuthorized = computed(() => store.getters['user/USER_AUTHORIZED']);

        // локальные данные пользователя
        const cartProducts = computed(() => store.getters['localStorage/BASKET_PRODUCTS']);
        const drugstoreId = computed(() => store.getters['localStorage/DRUGSTORE_ID']);

        const app = computed(() => $q.platform.is.cordova);

        const isFavourite = computed(() => {
            if (userAuthorized.value) {
                return isLocalFavourite.value;
            } else {
                const favourites = userStorageFavouriteProducts.value;
                return favourites?.find((item) => item === product.value.id);
            }
        });

        const notAvailable = computed(() => {
            return !product.value.qDs
                && (product.value.preorder?.balance !== undefined && !product.value.preorder?.balance
                    || product.value.preorder?.preorder_balance !== undefined && !product.value.preorder?.preorder_balance || !product.value.preorder);
        });

        const priceFrom = computed(() => {
            return false;
            // return product.value.inventory_list.length && !product.value.preorder.preorder_balance
            //     ? product.value.min_price
            //     : null;
        });

        const inCart = ref(false);

        const description = computed(() => {
            if (product.value?.description)
                for (let item of product.value?.description) {
                    if (item.value) {
                        product.value?.description.forEach((item) => {
                            item.show = false;
                        });

                        return ref(product.value?.description);
                    }
                }

            return null;
        });

        const termoText = computed(() => {
            let text = null;
            product.value.description.forEach((item) => {
                if (item.title == 'Условия хранения') {
                    text = item.value;
                }
            });

            if (text) {
                return text;
            } else return 'Препарат следует хранить в сухом, защищенном от света месте при температуре от 2° до 8°С.';
        });

        const promotionNameplate = computed(() => {
            if (Array.isArray(product?.value.productActivities) && product.value.productActivities.length > 0 && product.value.productActivities[0].title === 'Товар дня') {
                return 'bg-blue-10';
            }
            if ((product.value.discount800 || 0) > 0 || (product.value.discount300 || 0) > 0 || (product.value.priceCrossed && !notAvailable.value)) {
                return 'bg-negative';
            }
            return '';
        });

        const openWindow = (value) => {
            let link = city.value ? `/${city.value.slug}${value}` : `${value}`;
            if (process.env.CLIENT)
                window.open(link, '_blank');
        };

        // watch(() => route.params.productId, async (value) => {
        //     // product.value = null;
        //     // productAnalogs.value = null;
        //     // inventoryList = {};
        //     // productId.value = value;

        //     // if (productId.value) {
        //     //     await fetchProduct();
        //     //     await fetchProductAnalogs();
        //     //     await getDrugstores();
        //     // }
        // });

        // удаление товара из корзины для авторизоаванных
        const delProductInCart = async (id = product.value.id) => {
            const in_basket = false;

            try {
                await store.dispatch('basketNew/DELETE_PRODUCT_FROM_BASKET', {id});

                inCart.value = false;

                try {
                    window.dataLayer.push({
                        'ecommerce': {
                            'currencyCode': 'RUB',
                            'remove': {
                                'products': [
                                    {
                                        'id': product.value.id,
                                        'name': product.value.name + product.value.subtitleShort,
                                        'brand': product.value.manufacture,
                                        'price': product.value.price,
                                    },
                                ],
                            },
                        },
                    });
                } catch {
                }
            } catch (error) {
                $q.notify({
                    color: 'negative',
                    message: error.message,
                });
            }
            ;
        };

        // добавление товара в корзину
        const addToCart = async () => {
            window?.TapticEngine?.unofficial.weakBoom();
            userAuthorized.value
                ? await putProductInCart()
                : await putProductInLocalCart();

            try {
                ym(72234883, 'reachGoal', 'klik-korzina');

                window.dataLayer.push({
                    'ecommerce': {
                        'currencyCode': 'RUB',
                        'add': {
                            'products': [
                                {
                                    'id': product.value.id,
                                    'name': product.value.name + product.value.subtitleShort,
                                    'brand': product.value.manufacture,
                                    'price': product.value.price,
                                },
                            ],
                        },
                    },
                });
            } catch {
            }
        };

        // добавление товара в корзину для авторизоаванных
        const putProductInCart = async () => {
            loading.value = true;
            const in_basket = false;

            if (amount.value && amount.value > 0) {
                try {
                    await store.dispatch('basketNew/PUT_PRODUCT_IN_BUSKET', {
                        product: {
                            id: product.value.id,
                            amount: amount.value,
                            checked: true,
                        },
                        in_basket,
                    });

                    inCart.value = true;
                } catch (error) {
                    $q.notify({
                        color: 'negative',
                        message: 'Произошла ошибка. Повторите попытку позже',
                    });
                }
                ;
            }

            loading.value = false;
        };

        const putProductInLocalCart = async (id = product.value.url) => {
            loading.value = true;

            const payload = await store.dispatch('products/GET_PRODUCT_BY_SLUG', {id});
            await store.dispatch('localStorage/SAVE_LOCAL_DATA', payload);
            //store.commit('localStorage/ADD_TO_CART', payload);

            inCart.value = true;

            loading.value = false;
        };

        // переход в корзину
        const goToCart = () => {
            router.push('/basket');
        };

        // генерация хлебных крошек
        const setCrumbPath = async () => {
            // for (let i = 0; i < product.value.category_path.length; i++) {
            //     let item = product.value.category_path[i];
            //     routeObj.push({
            //         title: item.title,
            //         link: `/catalog/${item.id}`,
            //     });
            // }
            // routeObj.push({
            //     title: product.value.name,
            //     link: '',
            // });
        };

        // // добавление/удаление из избранного
        const updateFavourite = async () => {
            if (isFavourite.value) {
                userAuthorized.value
                    ? deleteProductFromUserFav()
                    : await store.dispatch('localStorage/DELETE_FAVOURITE_PRODUCT', product.value.id);
            } else {
                userAuthorized.value
                    ? addProductToUserFav()
                    : await store.dispatch('localStorage/ADD_FAVOURITE_PRODUCT', product.value.id);
            }
        };

        // // добавление/удаление из избранного
        const deleteProductFromUserFav = async () => {
            try {
                await store.dispatch('user/DELETE_FAVOURITE_PRODUCT', product.value.id);
                await store.commit('user/DELETE_USER_FAVOURITE_PRODUCT', product.value.id);
                isLocalFavourite.value = false;
            } catch (e) {
                isLocalFavourite.value = true;
            }
        };

        const addProductToUserFav = async () => {
            try {
                await store.dispatch('user/ADD_FAVOURITE_PRODUCT', product.value.id);
                isLocalFavourite.value = true;
            } catch (e) {
                isLocalFavourite.value = false;
            }
        };

        // изменение кол-ва товара
        const setAmount = async (pm) => {
            if (pm) {
                amount.value++;
            } else {
                if (!(amount.value - 1) || amount.value - 1 < 0) {
                    userAuthorized.value
                        ? await delProductInCart()
                        : await store.dispatch('localStorage/DELETE_ITEM', product.value.id);
                    amount.value = 1;
                    inCart.value = false;
                    return;
                } else {
                    amount.value--;
                }
            }

            if (userAuthorized.value) {
                /**
                 * Если пользователь авторизован
                 * ставим задержку на отправку данных о количестве товара в корзине в 1 сек.
                 */

                if (amountTimer.value) {
                    clearTimeout(amountTimer.value);
                }
                amountTimer.value = setTimeout(await putProductInCart, 300);
            } else {
                // если пользователь НЕ авторизован
                // сохраняем кол-во товара локально в браузере
                await store.dispatch('localStorage/UPDATE_LOCAL_DATA', {
                    id: product.value.id,
                    amount: amount.value,
                });
                // store.commit('localStorage/SET_AMOUNT', {
                //     id: product.value.id,
                //     amount: amount.value,
                // });
            }
        };

        const getCount = (array) => {
            let is_stock = 0;
            let is_preorder = 0;

            array.forEach((item) => {
                if (item.is_stock) {
                    is_stock += 1;
                }

                if (item.is_preorder) {
                    is_preorder += 1;
                }
            });

            return {
                is_stock,
                is_preorder,
                sum: is_stock + is_preorder,
            };
        };

        const calcToProduct = ({inventoryList, amount, preorder}) => {
            const localInventories = {};

            if (!notAvailable.value)
                inventoryList
                    .forEach(({drugstoreId, drugstoreBalance}) => {
                        if (drugstoreBalance >= amount) {
                            localInventories[drugstoreId] = {
                                is_stock: true,
                                is_preorder: false,
                            };
                        } else if (preorder?.preorderBalance >= amount) {
                            localInventories[drugstoreId] = {
                                is_stock: false,
                                is_preorder: true,
                            };
                        } else {
                            localInventories[drugstoreId] = {
                                is_stock: false,
                                is_preorder: false,
                            };
                        }
                    });

            return localInventories;
        };

        const generateInventories = () => {
            if (product.value) {
                const localInventories = {};

                [{...product.value, amount: amount.value}]
                    .forEach((product) => {
                        Object.entries(calcToProduct(product))
                            .forEach(([key, value]) => {
                                if (localInventories[key] === undefined) {
                                    localInventories[key] = [];
                                }

                                localInventories[key].push(value);
                            });
                    });

                Object.entries(localInventories)
                    .forEach(([key, value]) => {
                        const count = getCount(value);
                        const total = count.sum;

                        localInventories[key] = [];

                        if (count.is_stock) {
                            const label = count.is_stock !== 1
                                ? `в наличии ${count.is_stock} шт.`
                                : 'в наличии';

                            localInventories[key].push({
                                color: 'positive',
                                label,
                            });

                            if (total === 0) {
                                localInventories[key].available = true;

                                return;
                            } else {
                                localInventories[key].available = false;
                            }
                        }

                        if (count.is_preorder) {
                            const label = count.is_preorder !== 1
                                ? `заказать со склада ${count.is_preorder} шт.`
                                : 'заказать со склада';

                            localInventories[key].push({
                                color: 'positive',
                                label,
                            });
                        }

                        if (count.sum !== 1) {
                            const label = total > 0
                                ? `нет в наличии ${total} шт.`
                                : 'нет в наличии';

                            localInventories[key].push({
                                color: 'negative',
                                label,
                            });
                        }
                    });

                inventories.value = localInventories;
            }
        };

        const preventAmoutUp = computed(() => {
            if (product.value.limit < 0) {
                return amount.value >= product.value.totalCount;
            } else if (product.value.limit == 0 || product.value.pku) {
                return false;
            } else if (product.value.limit > 0) {
                return amount.value >= product.value.limit;
            }
            return false;
        });

        const reviews = computed(() => {
            return null;
        });

        const showReviewForm = () => {
            reviewForm.value = true;

            try {
                ym(72234883, 'reachGoal', 'klik-otzyv');
            } catch {
            }
        };

        // вомзожна ли бесплатная доставка
        const freeDelivery = computed(() => {
            return product.value.delivery && (!product.value.isPrescription || product.value.isErp);
        });

        // возможна ли доставка
        const delivery = computed(() => {
            return !product.value.isPrescription || product.value.isErp;
        });

        // рассчёт даты получения товара от поставщика
        const plannedDate = computed(() => {
            // если у поставщика нет товара
            if (!product.value.preorder?.preorder_balance)
                return;

            let distantDate = new Date(product.value.preorder?.preorder_supply_date);

            if (new Date() > distantDate) {
                return new Date(product.value.preorder?.preorder_next_supply_date).toLocaleDateString();
            } else {
                return new Date(distantDate).toLocaleDateString();
            }
        });

        const subscribeProduct = async () => {
            if (!userAuthorized.value) {
                showAuth();
            } else {
                if (!userEmail.value) {
                    $q.notify({
                        color: 'negative',
                        message: 'Для получения уведомлений укажите e-mail',
                    });
                } else {
                    try {
                        await store.dispatch('user/ADD_SUBSCRIPTION', product.value.id);
                        subscribe.value = true;
                        $q.notify({
                            color: 'positive',
                            message: 'Ожидайте уведомление на электронную почту',
                        });
                        try {
                            ym(72234883, 'reachGoal', 'klik-postuplenie');
                        } catch {
                        }
                    } catch (error) {
                        $q.notify({
                            color: 'negative',
                            message: 'Произошла ошибка. Повторите попытку позже',
                        });
                    }
                    ;
                }
            }
        };

        const unSubscribeProduct = async () => {
            try {
                await store.dispatch('user/DELETE_SUBSCRIPTION', product.value.id);
                subscribe.value = false;
            } catch (error) {
                $q.notify({
                    color: 'negative',
                    message: 'Произошла ошибка. Повторите попытку позже',
                });
            }
            ;
        };

        const userSubscribtions = computed(() => store.getters['user/USER_SUBSCRIPTIONS']);

        const isSubscribe = computed(() => {
            const subscribtions = userSubscribtions.value;
            return subscribtions?.find((item) => item === product.value.id);
        });

        const showAuth = () => {
            store.commit('auth/SET_ENTRY_AUTH', 'signin');
        };

        const userEmail = computed(() => store.getters['user/USER_EMAIL']);
        const activeAnchorLink = ref('overall');

        const anchorLinks = computed(() => [{
            label: 'Основное',
            value: 'overall',
            condition: true,
        }, {
            label: 'Аналоги',
            value: 'analogs-unavaliable',
            condition: productAnalogs.value?.length && notAvailable.value,
        }, {
            label: 'Рекомендации',
            value: 'additional',
            condition: additionalSales.value?.length,
        }, {
            label: 'Адреса',
            value: 'drugstores',
            condition: drugstores.value && !notAvailable.value,
        }, {
            label: 'Аналоги',
            value: 'analogs',
            condition: productAnalogs.value?.length && !notAvailable.value,
        }, {
            label: 'Инструкция',
            value: 'instruction',
            condition: description?.value,
        }, {
            label: 'Форма',
            value: 'formfactor',
            condition: formFactor.value?.length,
        }, {
            label: 'Отзывы',
            value: 'reviews',
            condition: true,
        }]);


        const scrollTo = (id, value, bool, idx) => {
            if (idx && bool !== null) {
                description.value.value[idx]
                    .show = bool;
            }
            currentInstruction.value = id;
            setTimeout(() => {
                const element = document.getElementById(id);
                const yOffset = -150;
                const topY = element?.getBoundingClientRect().top + window.pageYOffset + yOffset;
                const bottomY = element?.getBoundingClientRect().bottom + window.pageYOffset + yOffset;
                window.scrollTo({behavior: 'smooth', top: topY});
            }, 200);
            activeAnchorLink.value = value;
        };


        const drugstoresTodayText = computed(() => {
            if (product.value.qDs > 4 && product.value.qDs < 20 || product.value.qDs % 10 >= 5 && product.value.qDs % 10 <= 9 || product.value.qDs % 10 == 0)
                return 'аптеках';
            if (product.value.qDs === 1 || product.value.qDs % 10 == 1)
                return 'аптеке';
            return 'аптеках';
        });

        const drugstoresPreorderText = computed(() => {
            let n = drugstoresCount.value.length;

            if (n > 4 && n < 20 || n % 10 >= 5 && n % 10 <= 9 || n % 10 == 0)
                return 'аптеках';
            if (n === 1 || n % 10 == 1)
                return 'аптеке';
            return 'аптеках';
        });

        const orthopedicsDrugstoresPreorderText = computed(() => {
            let n = orthopedicsDrugstores.value.length;

            if (n > 4 && n < 20 || n % 10 >= 5 && n % 10 <= 9 || n % 10 == 0)
                return 'аптеках';
            if (n === 1 || n % 10 == 1)
                return 'аптеке';
            return 'аптеках';
        });

        const opticsDrugstoresPreorderText = computed(() => {
            let n = opticsDrugstores.value.length;

            if (n > 4 && n < 20 || n % 10 >= 5 && n % 10 <= 9 || n % 10 == 0)
                return 'аптеках';
            if (n === 1 || n % 10 == 1)
                return 'аптеке';
            return 'аптеках';
        });

        const isApp = computed(() => process.env.MODE === 'cordova');

        const headerHeight = computed(() => {
            return process.env.CLIENT
                ? document.querySelector('.header')?.offsetHeight
                : 0;
        });

        const goScroll = () => {
            if (process.env.CLIENT) {
                if (pageYOffset > headerHeight.value - 38) {
                    if (fixTitle.value === false) {
                        fixTitle.value = true;
                    }
                } else {
                    if (fixTitle.value === true) {
                        fixTitle.value = false;
                    }
                }
            }
        };

        const isOrthopedics = computed(() => product.value.groupCategory.code == '000000496');

        const isOptics = computed(() => product.value.groupCategory.code == '000000569');

        const goTo = (url) => {
            router.push(`${url}`);
        };
        // Инициализация наблюдателей
        const initObservers = () => {

            // Функция обработки скролла
            const handleScroll = () => {
                const sections = anchorLinks.value.map((item) => {
                    if (item.condition) {
                        return {
                            ...item,
                            elem: document.querySelector(`#${item.value}`),
                        };
                    }
                    return null;
                }).filter(Boolean);
                const windowHeight = window.innerHeight || document.documentElement.clientHeight;

                sections.forEach((section, idx) => {
                    const rect = section.elem.getBoundingClientRect();
                    if (rect.top <= windowHeight / 2 && rect.bottom > windowHeight / 2) {
                        activeAnchorLink.value = section.value;
                    }
                });
            };
            const debouncedScroll = debounce(handleScroll, 0);
            document.addEventListener('scroll', debouncedScroll);
            onUnmounted(() => {
                if (process.env.CLIENT) {
                    document.removeEventListener('scroll', debouncedScroll);
                }
            });
        };
        watch(activeAnchorLink, (value, oldValue) => {
            if (process.env.CLIENT) {
                const widthTopAnchorElem = document.querySelector(`#topAnchor-${activeAnchorLink.value}`);
                let widthTopAnchor = 0;
                if (widthTopAnchorElem) {
                    widthTopAnchor = widthTopAnchorElem.offsetWidth + 16;
                }
                const currentIndex = anchorLinks.value.findIndex((item) => item.value === oldValue);
                const nextIndex = anchorLinks.value.findIndex((item) => item.value === value);
                if (currentIndex < nextIndex) {
                    scrollPosition.value += widthTopAnchor;
                    scrollAreaFull.value?.setScrollPosition('horizontal', scrollPosition.value);
                    scrollAreaFixed.value?.setScrollPosition('horizontal', scrollPosition.value);
                } else {
                    scrollPosition.value -= widthTopAnchor;
                    scrollAreaFull.value?.setScrollPosition('horizontal', scrollPosition.value);
                    scrollAreaFixed.value?.setScrollPosition('horizontal', scrollPosition.value);
                }

            }


        });


        watch(product, () => {
            if (!isSubscribe.value && notAvailable.value) {
                subscribe.value = false;
            }
            if (!userAuthorized.value) {
                checkLocalBasket();
            } else {
                checkProdInBasket();
            }
        });
        watch(() => cartProducts.value, () => {
            if (!userAuthorized.value) {
                let localProd = cartProducts.value?.find((item) => item.id === product.value.id);

                if (localProd) {
                    amount.value = localProd.amount;
                    inCart.value = true;
                } else {
                    amount.value = 1;
                    inCart.value = false;
                }
            }
        });

        const checkLocalBasket = () => {
            let localProd = cartProducts.value?.find((item) => item.id === product.value.id);

            if (localProd) {
                amount.value = localProd.amount;
                inCart.value = true;
            } else {
                amount.value = 1;
                inCart.value = false;
            }
            ;
        };

        const checkProdInBasket = () => {
            if (product.value.inBasket) {
                amount.value = product.value.inBasket;
                inCart.value = true;
            } else {
                amount.value = 1;
                inCart.value = false;
            }
        };

        const shares = computed(() => [{
            title: 'ВКонтакте',
            icon: 'vk-round',
            link: `http://vk.com/share.php?url=https://etabl.ru/product/${product.value.url}&title=${product.value.name} ${product.value.subtitleShort}&description=${product.value.subtitleShort}&image=${product.value.previewImage}&noparse=true`,
        }, {
            title: 'Одноклассники',
            icon: 'ok-round',
            link: `https://connect.ok.ru/offer?url=https://etabl.ru/product/${product.value.url}`,
        }, {
            title: 'Telegram',
            icon: 'telegram',
            link: `https://t.me/share/url?url=https://etabl.ru/product/${product.value.url}&text=${product.value.name} ${product.value.subtitleShort}`,
        }, {
            title: 'WhatsApp',
            icon: 'whats-app',
            link: `https://api.whatsapp.com/send?text=${product.value.name} ${product.value.subtitleShort} https://etabl.ru/product/${product.value.url}`,
        }]);

        const copy = async () => {
            copyToClipboard(`https://etabl.ru/product/${product.value.url}`);
            $q.notify({
                color: 'positive',
                message: 'Ссылка скопирована',
            });
            sharesList.value = false;
        };

        const closeReviewForm = async () => {
            reviewForm.value = false;
        };

        const productRating = computed(() => {
            let rating = 0;

            product.value.reviews.forEach((item) => rating += item.rating);

            return (rating / product.value.reviews.length).toFixed(1);
        });

        const productRatingRound = computed(() => Math.round(+productRating.value));
        const observers = ref({});

        onMounted(async () => {
            if (process.env.CLIENT) {
                await initObservers();
            }
            if (!userAuthorized.value) {
                checkLocalBasket();
            } else {
                checkProdInBasket();
            }

            if (product.value.isFavourite)
                isLocalFavourite.value = true;

            await setCrumbPath();
            await generateInventories();

            if (!isSubscribe.value && notAvailable.value) {
                subscribe.value = false;
            }

            if (process.env.CLIENT) {
                window.addEventListener('scroll', goScroll);
            }

            if (userAuthorized.value)
                await store.dispatch('advertisement/GET_HISTORY');

            try {
                window.dataLayer.push({
                    'ecommerce': {
                        'currencyCode': 'RUB',
                        'detail': {
                            'products': [
                                {
                                    'id': product.value.id,
                                    'name': product.value.name + product.value.subtitleShort,
                                    'brand': product.value.manufacture,
                                    'price': product.value.price,
                                    'category': product.value.type,
                                },
                            ],
                        },
                    },
                });
            } catch {
            }
        });

        const limit = () => {
            $q.notify({
                color: 'positive',
                message: 'Внимание! Количество ограничено',
            });
        };

        const share = () => {
            let options = {
                url: `https://${process.env.APP_SERVICE_HOSTNAME}${route.path}`,
            };

            window?.plugins.socialsharing.shareWithOptions(options);
        };

        return {
            promotionNameplate,
            userAddress,
            observers,
            showMap,
            router,
            routeObj,
            product,
            notAvailable,
            priceFrom,
            loading,
            inCart,
            isFavourite,
            updateFavourite,
            productAnalogs,
            addToCart,
            fixedMenu,
            goToCart,
            amount,
            setAmount,
            description,
            currentCharact,
            formFactor,
            drugstores,
            preventAmoutUp,
            limit,
            reviewForm,
            showAllReviews,
            reviews,
            email,
            name,
            freeDelivery,
            delivery,
            plannedDate,
            showReviewForm,
            subscribeProduct,
            subscribe,
            userSubscribtions,
            isSubscribe,
            unSubscribeProduct,
            showAuth,
            userAuthorized,
            userEmail,
            anchorLinks,
            scrollTo,
            app,
            drugstoresTodayText,
            drugstoresPreorderText,
            share,
            isApp,
            currentInstruction,
            history,
            fixTitle,
            headerHeight,
            goScroll,
            salePercent,
            additionalSales,
            isOrthopedics,
            orthopedicsDrugstoreList,
            orthopedicsDrugstores,
            orthopedicsDrugstoresPreorderText,
            isLocalFavourite,
            deleteProductFromUserFav,
            addProductToUserFav,
            goTo,
            checkLocalBasket,
            checkProdInBasket,
            sharesList,
            shares,
            copy,
            drugstoresCount,
            isOptics,
            opticsDrugstores,
            opticsDrugstoresPreorderText,
            closeReviewForm,
            productRating,
            productRatingRound,
            showErpTooltip,
            city,
            openWindow,
            showPrecriptionTooltip,
            showTermoTooltip,
            termoText,
            activeAnchorLink,
            scrollAreaFixed,
            scrollAreaFull,
            cartProducts,
        };
    },
};
</script>

<style lang="scss" scoped>
.product-header {
    padding-top: Max(constant(safe-area-inset-top), 8px);
    padding-top: Max(env(safe-area-inset-top), 8px);
}

.additional {
    background: #E2F0E8;
    overflow: hidden;
    //height: 184px;
}

.product {
    background: $secondary;

    &__button-block {
        border-radius: $mobile-border-radius $mobile-border-radius 0 0;
        box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.15);
        bottom: Max(calc(50px + constant(safe-area-inset-bottom)), 57px);
        bottom: Max(calc(50px + env(safe-area-inset-bottom)), 57px);
    }

    &__counter {
        overflow: hidden;
        border-radius: 10px;
        color: $primary;

        font: {
            size: 12px;
            weight: 500;
        }
    }

    &__button-counter {
        min-height: 100%;
        background-color: $accent;
        color: $primary;
        text-transform: none;
        border-radius: 0;
        padding: 0 !important;

        font: {
            size: 16px;
            weight: 400;
        }
    }

    &__button-disable {
        min-height: 100%;
        background-color: $accent;
        color: $medium-gray;
        text-transform: none;
        border-radius: 0;
        padding: 0 !important;

        font: {
            size: 16px;
            weight: 400;
        }
    }

    &__map-card {
        background-size: contain !important;
        border-radius: $mobile-border-radius;
    }

    &__disable {
        z-index: 1;
        background: rgba(255, 255, 255, 0.4);
        height: 200px;
        width: 100%;
        position: absolute;
    }
}

.product-info {
    // box-shadow: 0px -2px 5px rgba(0, 0, 0, 0.1);
    // border-radius: 16px;
    // background-color: $grey-5;
    min-height: calc(100vh - 300px);
    margin-bottom: 140px;
}

h2 {
    color: #383838;
    line-height: 18px;
    font-size: 16px;
    padding-bottom: 8px;
    padding-bottom: 16px;
}

.review-form {
    border-radius: 20px 20px 0 0;
}

.anchors {
    height: 40px;

    &.anchors-instruction {
        height: 60px;
    }

    &__list {
        text-decoration: underline;

        &:nth-child(1) {
            padding-left: 8px;
        }
    }

    &__instruction {

        &:nth-child(1) {
            padding-left: 8px;
        }

        &-item {
            text-decoration: underline;
            //border-bottom: 1px solid $primary;
            color: $primary;
        }
    }

    :deep(.q-scrollarea__bar--h) {
        bottom: -12px;
    }
}

.share {
    position: absolute;
    right: 16px;
}

.fixed {
    width: 100%;
    background-color: #fbfafa;
    z-index: 2;
    top: 0;
    margin-top: constant(safe-area-inset-top) !important;
    margin-top: env(safe-area-inset-top) !important;
}

.package-form {
    padding: 4px 16px;
    outline: 1px solid $grey-14;
    text-decoration: none;
    border-radius: 16px;
}

.active-form {
    //background: $positive;
    color: $positive !important;
    outline: 1px solid $positive;
    border-radius: 16px;
}

.custom-a-top-left {
    top: 2%;
    left: 1%;
}


</style>
